<template>
  <div v-if="!isLoading">
    <PortalTarget name="agreement-popup" />
    <VoucherBanner banner-id="voucher_index" />

    <div :class="'voucher-wrap ' + (device === 'ios' ? 'voucher-ios' : '')">
      <nav v-if="isTabView" class="ticket-tab">
        <ul>
          <li :class="selectedTabClass('wavve')">
            <a href="#" @click.prevent="moveToVoucherTab('wavve')">웨이브</a>
          </li>
          <li :class="selectedTabClass('partner')">
            <a href="#" @click.prevent="moveToVoucherTab('partner')">제휴</a>
          </li>
        </ul>
      </nav>
      <section :class="sectionClass">
        <h2 class="page-text">방송/영화/해외 시리즈 무제한!</h2>
        <ul class="voucher-list">
          <li
            v-for="(voucher, index) in voucherList"
            :key="`voucher__${index}`"
          >
            <VoucherItem
              :key="`${voucherType}__${index}__${voucher?.quality_name}__item`"
              :voucher="voucher"
              :voucher-type="voucherType"
              :selected-product-id="selectedProductId"
              @on-click-purchase-wavve="onClickPurchase(voucher, $event)"
              @on-click-purchase-partner="purchase(voucher, $event)"
            />
          </li>
        </ul>
        <div v-if="isAndroidOS" class="common-benefit">
          <h4>* Google Play 첫 결제 시, 첫 달 ￦100 프로모션</h4>
          <ul class="exclamation-list">
            <li
              v-for="(text, index) in voucherAndroidOsNotice"
              :key="`android_os_notice__${index}`"
            >
              <span v-html="text"></span>
            </li>
          </ul>
        </div>
        <div class="common-benefit">
          <h4>이용권 공통 혜택</h4>
          <ul class="common-benefit-list">
            <li
              v-for="(item, index) in voucherCommonBenefits"
              :key="`common_benefits__${index}`"
            >
              <span v-html="item"></span>
            </li>
          </ul>
        </div>
      </section>
      <VoucherBottomGuide :device="device" />
    </div>
    <loading-with-props :show-loading="checkActionLoading" />
  </div>
</template>

<script>
  import { VoucherService } from '@/common/api/api.service'
  import VoucherBottomGuide from '@/components/lnb/voucher/VoucherBottomGuide'
  import utils from '@/common/util/utils'
  import VoucherBanner from '@/components/lnb/voucher/VoucherBanner'
  import LoadingWithProps from '@/components/LoadingWithProps.vue'
  import { get, findIndex } from 'lodash'
  import { voucherPurchase } from '@/common/util/common'
  import {
    DEVICE_TYPE_ANDROID,
    DEVICE_TYPE_IOS,
  } from '@/common/devicetype.const'
  import {
    PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE,
    PRODUCT_TYPE_SUBSCRIPTION,
  } from '@/common/constant'
  import braze from '@/common/util/braze'
  import {
    normalizePurchaseParams,
    getPurchaseProperties,
  } from '@/common/util/braze.util'
  import { getCheckPurchaseAction } from '@/common/requests/data-fetch/get-check-purchase-action'
  import { PURCHASE_ACTION_TYPE } from '@/common/normalize'
  import { putUpcomingPayments } from '@/common/requests/data-fetch/put-upcoming-payments'
  import {
    MSG_CHECK_PURCHASE_IN_APP_ALERT,
    MSG_CHECK_PURCHASE_NETWORK_ERROR,
  } from '@/common/util/coupon/const'
  import { confirmChangeUpcomingVoucher } from '@/common/util/voucher'
  import {
    VOUCHER_COMMON_BENEFITS,
    VOUCHER_ANDROID_OS_NOTICE,
  } from '@/components/lnb/voucher/voucher-text/const.js'
  import VoucherItem from '@/components/lnb/voucher/ui/VoucherItem.vue'

  export default {
    name: 'VoucherIndex',
    components: {
      VoucherBottomGuide,
      VoucherBanner,
      LoadingWithProps,
      VoucherItem,
    },
    data() {
      return {
        voucherList: [],
        voucherType: 'wavve',
        dataList: [],
        device: utils.cookies.getDevice(),
        isLoading: true,
        recommendVoucher: 'standard',
        selectedProductId: null,
        checkActionLoading: false,
        voucherAndroidOsNotice: VOUCHER_ANDROID_OS_NOTICE,
        voucherCommonBenefits: VOUCHER_COMMON_BENEFITS,
      }
    },
    computed: {
      isTabView() {
        return (
          utils.cookies.getDevice() !== DEVICE_TYPE_IOS &&
          utils.getPgName() !== PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE
        )
      },
      sectionClass() {
        return this.voucherType === 'partner' ? 'partner' : ''
      },
      isAndroidOS() {
        return this.device === DEVICE_TYPE_ANDROID
      },
    },
    watch: {
      $route() {
        this.setData()
      },
    },
    created() {
      this.setData()
    },
    mounted() {
      window.addEventListener('message', this.postMessage)
    },
    beforeDestroy() {
      window.removeEventListener('message', this.postMessage)
    },
    methods: {
      setNumberCommas(data) {
        if (!data) return 0
        return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      setData() {
        this.isLoading = true
        this.voucherType = get(this.$route, 'query.voucherType', 'wavve')
        const store =
          this.device === DEVICE_TYPE_ANDROID ? utils.getPgName() : 'wavve'
        VoucherService.getVoucherPurchase({ store, device: this.device }).then(
          ({ data }) => {
            this.dataList = JSON.parse(get(data, 'data.json', ''))
            const wavveVoucherIndex = findIndex(this.dataList, {
              passgroup_type: 'wavve',
            })
            const partnerVoucherIndex = findIndex(this.dataList, {
              passgroup_type: 'partner',
            })
            this.voucherList = get(
              this.dataList,
              [
                this.voucherType === 'wavve'
                  ? wavveVoucherIndex
                  : partnerVoucherIndex,
                'productgroups',
                '0',
                'products',
              ],
              [],
            )
            this.isLoading = false
          },
        )
      },
      async onClickPurchase(voucher, productInfo) {
        console.log('voucher', voucher, '\nproductInfo', productInfo)
        // TODO: 제휴이용권 예외처리 필요
        if (utils.cookies.getCredential() === 'none') {
          window.location.href = `/member/login.html?referer=${encodeURIComponent(location.href)}`
          return
        }
        const productId = get(productInfo, 'productid', '')
        this.selectedProductId = productId
        this.checkActionLoading = true
        const checkPurchaseResult = await getCheckPurchaseAction({
          productId,
        })
        this.checkActionLoading = false
        if (!checkPurchaseResult || !checkPurchaseResult?.data) {
          // checkPurchaseAction api 호출 실패
          utils.alert(MSG_CHECK_PURCHASE_NETWORK_ERROR)
          return
        }

        const { actionType, requestProductInfo } = checkPurchaseResult.data

        const { PAYLETTER_CALL, PUT_UPCOMING_PAYMENTS, SHOW_ALERT } =
          PURCHASE_ACTION_TYPE

        switch (actionType) {
          case PAYLETTER_CALL: {
            // 기존 동작과 동일 (페이레터 결제창 호출)
            this.purchase(voucher, productInfo)
            return
          }
          case PUT_UPCOMING_PAYMENTS: {
            // 결제 변경 api 호출
            const answer = confirmChangeUpcomingVoucher({
              requestProductInfo,
              voucher,
              productInfo,
            })
            if (!answer) return
            this.changeUpcomingPayment({ productId })
            return
          }
          case SHOW_ALERT: {
            // 알럿창 (인앱결제 불가능 상품)
            utils.alert(MSG_CHECK_PURCHASE_IN_APP_ALERT)
            return
          }
          default: {
            // 기타 에러(네트워크 에러 등)
            utils.alert(MSG_CHECK_PURCHASE_NETWORK_ERROR)
          }
        }
      },

      purchase(voucher, productInfo) {
        const productId = get(productInfo, 'productid', '')
        const concurrency = get(voucher, 'concurrency.0', '')
        this.recommendVoucher = get(
          concurrency,
          'product_name',
          '',
        ).toLowerCase()

        const isExternal =
          get(concurrency, 'is_product_external', 'n').toUpperCase() === 'Y'
        const linkTarget = get(concurrency, 'external_link_target', '')
        if (isExternal) {
          if (this.device === DEVICE_TYPE_ANDROID) {
            location.href = get(concurrency, 'external_link_android', '')
          } else {
            window.open(
              get(concurrency, 'external_link_mobile', ''),
              linkTarget,
            )
          }
          return
        }

        const productTypeForGoogleIAP =
          utils.getPgName() === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE
            ? PRODUCT_TYPE_SUBSCRIPTION
            : ''
        const callbackParams = {
          next: 'setData',
          ...normalizePurchaseParams({
            ...get(voucher, 'concurrency.0', {}),
            ...productInfo,
          }),
        }
        voucherPurchase({
          deviceType: this.device,
          productId: productId,
          callbackAction: 'purchaseComplete',
          callbackParams,
          canceledCallbackAction: 'Cancel',
          pgName: utils.getPgName(),
          productTypeForGoogleIAP,
        })
      },
      async changeUpcomingPayment({ productId }) {
        const result = await putUpcomingPayments({
          data: {
            product_id: productId,
          },
        })
        if (result) {
          this.$router.replace({ name: 'subscription_ticket' })
        }
      },
      moveToVoucherTab(voucherType) {
        this.$router.push('/voucher/index?voucherType=' + voucherType)
      },
      selectedTabClass(voucherType) {
        return this.voucherType === voucherType ? 'selected' : ''
      },
      async postMessage(e) {
        if (e.origin === location.origin) {
          const { eventMessage, params = {} } = e.data
          if (eventMessage === 'purchaseComplete') {
            if (params.result === 'y') {
              braze.purchase(getPurchaseProperties(params))
            }
            const credential = utils.cookies.getCredential()
            const isMultiLine =
              Number(utils.cookies.userInfo('profilecount')) !== 1
            await utils.login.credentialAutoLogin(
              credential,
              isMultiLine,
              false,
            )
            switch (params.next) {
              case 'reload':
                window.location.reload(true)
                break
              case 'setData':
                this.setData()
                break
              default:
                break
            }
          }
        }
      },
    },
  }
</script>
